import React from "react";
import { useContentContext } from "./Content";

import styles from "./Content.module.css";

/**
 * @visibleName Content.Header
 */
const ContentHeader = ({ children }) => {
    // eslint-disable-next-line no-unused-vars
    const _ = useContentContext();

    return <div className={styles.header}>{children}</div>;
};

export default ContentHeader;
